import React from 'react';

interface ColorStyleProps {
    mainColor: string;
    lightColor: string;
}

const ColorStyle: React.FC<ColorStyleProps> = ({ lightColor, mainColor }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
            <path d="M22 44C16.1652 44 10.5695 41.6821 6.44365 37.5563C2.31785 33.4305 -1.62312e-07 27.8348 0 22C1.62312e-07 16.1652 2.31785 10.5695 6.44365 6.44365C10.5695 2.31785 16.1652 -6.95788e-08 22 0V22L22 44Z" fill={mainColor} />
            <path d="M22 0C27.8348 6.95788e-08 33.4305 2.31785 37.5563 6.44364C41.6821 10.5694 44 16.1652 44 22C44 27.8347 41.6822 33.4305 37.5564 37.5563C33.4306 41.6821 27.8348 44 22.0001 44L22 22V0Z" fill={lightColor} />
        </svg>
    );
};

export default ColorStyle;